/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const CarsListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional()
})

export const carsListResponseClientIdMax = 255;

export const carsListResponseNumLandingsMin = 0;
export const carsListResponseNumLandingsMax = 2147483647;

export const carsListResponsePropertyOneAddressOneRawMax = 200;

export const carsListResponsePropertyOneAddressOneFormattedMax = 200;

export const carsListResponsePropertyOneAddressOneStreetNumberMax = 20;

export const carsListResponsePropertyOneRegionMax = 255;

export const carsListResponsePropertyOneClientIdMax = 255;

export const carsListResponsePropertyOneLatDefault = 0;
export const carsListResponsePropertyOneLngDefault = 0;
export const carsListResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const carsListResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsListResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const carsListResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const carsListResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const carsListResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsListResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const carsListResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const carsListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const carsListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsListResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const carsListResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const carsListResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const carsListResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const carsListResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsListResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const carsListResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const carsListResponsePropertyOneBuildingNumberMax = 255;

export const carsListResponsePropertyOneContactOneNameMax = 255;

export const carsListResponseInstallationYearMin = 0;
export const carsListResponseInstallationYearMax = 2147483647;

export const carsListResponseModernizationYearMin = 0;
export const carsListResponseModernizationYearMax = 2147483647;

export const carsListResponseNumEntrancesMin = 0;
export const carsListResponseNumEntrancesMax = 2147483647;

export const carsListResponseSpeedFpmMin = 0;
export const carsListResponseSpeedFpmMax = 2147483647;

export const carsListResponseCapacityLbsMin = 0;
export const carsListResponseCapacityLbsMax = 2147483647;



export const CarsListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(carsListResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(carsListResponseNumLandingsMin).max(carsListResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(carsListResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(carsListResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(carsListResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(carsListResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(carsListResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(carsListResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(carsListResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsListResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(carsListResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsListResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsListResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsListResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(carsListResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsListResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsListResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(carsListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsListResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(carsListResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(carsListResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsListResponsePropertyOneAssignedConsultantOneUsernameMax).regex(carsListResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsListResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsListResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(carsListResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(carsListResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(carsListResponseInstallationYearMin).max(carsListResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(carsListResponseModernizationYearMin).max(carsListResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(carsListResponseNumEntrancesMin).max(carsListResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(carsListResponseSpeedFpmMin).max(carsListResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(carsListResponseCapacityLbsMin).max(carsListResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const CarsListResponse = zod.array(CarsListResponseItem)

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const carsCreateBodyClientIdMax = 255;


export const carsCreateBodyNumLandingsMin = 0;
export const carsCreateBodyNumLandingsMax = 2147483647;

export const carsCreateBodyInstallationYearMin = 0;
export const carsCreateBodyInstallationYearMax = 2147483647;

export const carsCreateBodyModernizationYearMin = 0;
export const carsCreateBodyModernizationYearMax = 2147483647;

export const carsCreateBodyNumEntrancesMin = 0;
export const carsCreateBodyNumEntrancesMax = 2147483647;

export const carsCreateBodySpeedFpmMin = 0;
export const carsCreateBodySpeedFpmMax = 2147483647;

export const carsCreateBodyCapacityLbsMin = 0;
export const carsCreateBodyCapacityLbsMax = 2147483647;



export const CarsCreateBody = zod.object({
  "clientId": zod.string().max(carsCreateBodyClientIdMax).nullish(),
  "name": zod.string().min(1),
  "numLandings": zod.number().min(carsCreateBodyNumLandingsMin).max(carsCreateBodyNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(carsCreateBodyInstallationYearMin).max(carsCreateBodyInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(carsCreateBodyModernizationYearMin).max(carsCreateBodyModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(carsCreateBodyNumEntrancesMin).max(carsCreateBodyNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(carsCreateBodySpeedFpmMin).max(carsCreateBodySpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(carsCreateBodyCapacityLbsMin).max(carsCreateBodyCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const carsCreateResponseClientIdMax = 255;

export const carsCreateResponseNumLandingsMin = 0;
export const carsCreateResponseNumLandingsMax = 2147483647;

export const carsCreateResponsePropertyOneAddressOneRawMax = 200;

export const carsCreateResponsePropertyOneAddressOneFormattedMax = 200;

export const carsCreateResponsePropertyOneAddressOneStreetNumberMax = 20;

export const carsCreateResponsePropertyOneRegionMax = 255;

export const carsCreateResponsePropertyOneClientIdMax = 255;

export const carsCreateResponsePropertyOneLatDefault = 0;
export const carsCreateResponsePropertyOneLngDefault = 0;
export const carsCreateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const carsCreateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsCreateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const carsCreateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const carsCreateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const carsCreateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsCreateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const carsCreateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const carsCreateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const carsCreateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsCreateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const carsCreateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const carsCreateResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const carsCreateResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const carsCreateResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsCreateResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const carsCreateResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const carsCreateResponsePropertyOneBuildingNumberMax = 255;

export const carsCreateResponsePropertyOneContactOneNameMax = 255;

export const carsCreateResponseInstallationYearMin = 0;
export const carsCreateResponseInstallationYearMax = 2147483647;

export const carsCreateResponseModernizationYearMin = 0;
export const carsCreateResponseModernizationYearMax = 2147483647;

export const carsCreateResponseNumEntrancesMin = 0;
export const carsCreateResponseNumEntrancesMax = 2147483647;

export const carsCreateResponseSpeedFpmMin = 0;
export const carsCreateResponseSpeedFpmMax = 2147483647;

export const carsCreateResponseCapacityLbsMin = 0;
export const carsCreateResponseCapacityLbsMax = 2147483647;



export const CarsCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(carsCreateResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(carsCreateResponseNumLandingsMin).max(carsCreateResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(carsCreateResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(carsCreateResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(carsCreateResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(carsCreateResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(carsCreateResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(carsCreateResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(carsCreateResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsCreateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(carsCreateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsCreateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsCreateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsCreateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(carsCreateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsCreateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsCreateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsCreateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(carsCreateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsCreateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(carsCreateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(carsCreateResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsCreateResponsePropertyOneAssignedConsultantOneUsernameMax).regex(carsCreateResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsCreateResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsCreateResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(carsCreateResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(carsCreateResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(carsCreateResponseInstallationYearMin).max(carsCreateResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(carsCreateResponseModernizationYearMin).max(carsCreateResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(carsCreateResponseNumEntrancesMin).max(carsCreateResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(carsCreateResponseSpeedFpmMin).max(carsCreateResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(carsCreateResponseCapacityLbsMin).max(carsCreateResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * One car's knowledge. Change or delete an entry through its property.
 */
export const CarsKnowledgeListParams = zod.object({
  "carPk": zod.string().uuid().describe('UUID of the parent car.')
})

export const CarsKnowledgeListQueryParams = zod.object({
  "q": zod.string().optional().describe('Full-text search over entry content, best match first. Falls back to a substring match when full-text search finds nothing.')
})

export const CarsKnowledgeListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "propertyId": zod.string().uuid(),
  "carId": zod.string().uuid().nullable(),
  "kind": zod.enum(['note', 'decision', 'commitment']).describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "content": zod.string(),
  "source": zod.enum(['manual', 'assistant', 'task']).describe('\* `manual` - Manual\n\* `assistant` - Assistant\n\* `task` - Task'),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "isAuthor": zod.boolean(),
  "task": zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string()
}).strict().nullable(),
  "supersedesId": zod.string().uuid().nullable(),
  "supersededById": zod.string().uuid().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable()
}).strict()
export const CarsKnowledgeListResponse = zod.array(CarsKnowledgeListResponseItem)

/**
 * One car's knowledge. Change or delete an entry through its property.
 */
export const CarsKnowledgeCreateParams = zod.object({
  "carPk": zod.string().uuid().describe('UUID of the parent car.')
})

export const carsKnowledgeCreateBodyContentMax = 4000;



export const CarsKnowledgeCreateBody = zod.object({
  "kind": zod.enum(['note', 'decision', 'commitment']).optional().describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "content": zod.string().min(1).max(carsKnowledgeCreateBodyContentMax),
  "source": zod.enum(['manual', 'assistant']).optional().describe('\* `manual` - manual\n\* `assistant` - assistant'),
  "supersedesId": zod.string().uuid().nullish(),
  "followUpDate": zod.string().date().nullish()
})

export const CarsKnowledgeCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "propertyId": zod.string().uuid(),
  "carId": zod.string().uuid().nullable(),
  "kind": zod.enum(['note', 'decision', 'commitment']).describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "content": zod.string(),
  "source": zod.enum(['manual', 'assistant', 'task']).describe('\* `manual` - Manual\n\* `assistant` - Assistant\n\* `task` - Task'),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "isAuthor": zod.boolean(),
  "task": zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string()
}).strict().nullable(),
  "supersedesId": zod.string().uuid().nullable(),
  "supersededById": zod.string().uuid().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "followUpTask": zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string()
}).strict().nullable()
}).strict().describe('A new entry, plus the follow-up task its commitment opened, if any.')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const CarsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.')
})

export const carsRetrieveResponseClientIdMax = 255;

export const carsRetrieveResponseNumLandingsMin = 0;
export const carsRetrieveResponseNumLandingsMax = 2147483647;

export const carsRetrieveResponsePropertyOneAddressOneRawMax = 200;

export const carsRetrieveResponsePropertyOneAddressOneFormattedMax = 200;

export const carsRetrieveResponsePropertyOneAddressOneStreetNumberMax = 20;

export const carsRetrieveResponsePropertyOneRegionMax = 255;

export const carsRetrieveResponsePropertyOneClientIdMax = 255;

export const carsRetrieveResponsePropertyOneLatDefault = 0;
export const carsRetrieveResponsePropertyOneLngDefault = 0;
export const carsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const carsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const carsRetrieveResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const carsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const carsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const carsRetrieveResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const carsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const carsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const carsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const carsRetrieveResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const carsRetrieveResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const carsRetrieveResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsRetrieveResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const carsRetrieveResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const carsRetrieveResponsePropertyOneBuildingNumberMax = 255;

export const carsRetrieveResponsePropertyOneContactOneNameMax = 255;

export const carsRetrieveResponseInstallationYearMin = 0;
export const carsRetrieveResponseInstallationYearMax = 2147483647;

export const carsRetrieveResponseModernizationYearMin = 0;
export const carsRetrieveResponseModernizationYearMax = 2147483647;

export const carsRetrieveResponseNumEntrancesMin = 0;
export const carsRetrieveResponseNumEntrancesMax = 2147483647;

export const carsRetrieveResponseSpeedFpmMin = 0;
export const carsRetrieveResponseSpeedFpmMax = 2147483647;

export const carsRetrieveResponseCapacityLbsMin = 0;
export const carsRetrieveResponseCapacityLbsMax = 2147483647;



export const CarsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(carsRetrieveResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(carsRetrieveResponseNumLandingsMin).max(carsRetrieveResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(carsRetrieveResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(carsRetrieveResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(carsRetrieveResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(carsRetrieveResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(carsRetrieveResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(carsRetrieveResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(carsRetrieveResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(carsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsRetrieveResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsRetrieveResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(carsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsRetrieveResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsRetrieveResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(carsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(carsRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(carsRetrieveResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsRetrieveResponsePropertyOneAssignedConsultantOneUsernameMax).regex(carsRetrieveResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsRetrieveResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsRetrieveResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(carsRetrieveResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(carsRetrieveResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(carsRetrieveResponseInstallationYearMin).max(carsRetrieveResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(carsRetrieveResponseModernizationYearMin).max(carsRetrieveResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(carsRetrieveResponseNumEntrancesMin).max(carsRetrieveResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(carsRetrieveResponseSpeedFpmMin).max(carsRetrieveResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(carsRetrieveResponseCapacityLbsMin).max(carsRetrieveResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const CarsUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.')
})

export const carsUpdateBodyClientIdMax = 255;


export const carsUpdateBodyNumLandingsMin = 0;
export const carsUpdateBodyNumLandingsMax = 2147483647;

export const carsUpdateBodyInstallationYearMin = 0;
export const carsUpdateBodyInstallationYearMax = 2147483647;

export const carsUpdateBodyModernizationYearMin = 0;
export const carsUpdateBodyModernizationYearMax = 2147483647;

export const carsUpdateBodyNumEntrancesMin = 0;
export const carsUpdateBodyNumEntrancesMax = 2147483647;

export const carsUpdateBodySpeedFpmMin = 0;
export const carsUpdateBodySpeedFpmMax = 2147483647;

export const carsUpdateBodyCapacityLbsMin = 0;
export const carsUpdateBodyCapacityLbsMax = 2147483647;



export const CarsUpdateBody = zod.object({
  "clientId": zod.string().max(carsUpdateBodyClientIdMax).nullish(),
  "name": zod.string().min(1),
  "numLandings": zod.number().min(carsUpdateBodyNumLandingsMin).max(carsUpdateBodyNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(carsUpdateBodyInstallationYearMin).max(carsUpdateBodyInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(carsUpdateBodyModernizationYearMin).max(carsUpdateBodyModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(carsUpdateBodyNumEntrancesMin).max(carsUpdateBodyNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(carsUpdateBodySpeedFpmMin).max(carsUpdateBodySpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(carsUpdateBodyCapacityLbsMin).max(carsUpdateBodyCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const carsUpdateResponseClientIdMax = 255;

export const carsUpdateResponseNumLandingsMin = 0;
export const carsUpdateResponseNumLandingsMax = 2147483647;

export const carsUpdateResponsePropertyOneAddressOneRawMax = 200;

export const carsUpdateResponsePropertyOneAddressOneFormattedMax = 200;

export const carsUpdateResponsePropertyOneAddressOneStreetNumberMax = 20;

export const carsUpdateResponsePropertyOneRegionMax = 255;

export const carsUpdateResponsePropertyOneClientIdMax = 255;

export const carsUpdateResponsePropertyOneLatDefault = 0;
export const carsUpdateResponsePropertyOneLngDefault = 0;
export const carsUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const carsUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsUpdateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const carsUpdateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const carsUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const carsUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsUpdateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const carsUpdateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const carsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const carsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const carsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const carsUpdateResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const carsUpdateResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const carsUpdateResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsUpdateResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const carsUpdateResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const carsUpdateResponsePropertyOneBuildingNumberMax = 255;

export const carsUpdateResponsePropertyOneContactOneNameMax = 255;

export const carsUpdateResponseInstallationYearMin = 0;
export const carsUpdateResponseInstallationYearMax = 2147483647;

export const carsUpdateResponseModernizationYearMin = 0;
export const carsUpdateResponseModernizationYearMax = 2147483647;

export const carsUpdateResponseNumEntrancesMin = 0;
export const carsUpdateResponseNumEntrancesMax = 2147483647;

export const carsUpdateResponseSpeedFpmMin = 0;
export const carsUpdateResponseSpeedFpmMax = 2147483647;

export const carsUpdateResponseCapacityLbsMin = 0;
export const carsUpdateResponseCapacityLbsMax = 2147483647;



export const CarsUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(carsUpdateResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(carsUpdateResponseNumLandingsMin).max(carsUpdateResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(carsUpdateResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(carsUpdateResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(carsUpdateResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(carsUpdateResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(carsUpdateResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(carsUpdateResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(carsUpdateResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(carsUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsUpdateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsUpdateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(carsUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsUpdateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsUpdateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(carsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(carsUpdateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(carsUpdateResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsUpdateResponsePropertyOneAssignedConsultantOneUsernameMax).regex(carsUpdateResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsUpdateResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsUpdateResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(carsUpdateResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(carsUpdateResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(carsUpdateResponseInstallationYearMin).max(carsUpdateResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(carsUpdateResponseModernizationYearMin).max(carsUpdateResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(carsUpdateResponseNumEntrancesMin).max(carsUpdateResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(carsUpdateResponseSpeedFpmMin).max(carsUpdateResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(carsUpdateResponseCapacityLbsMin).max(carsUpdateResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const CarsPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.')
})

export const carsPartialUpdateBodyClientIdMax = 255;


export const carsPartialUpdateBodyNumLandingsMin = 0;
export const carsPartialUpdateBodyNumLandingsMax = 2147483647;

export const carsPartialUpdateBodyInstallationYearMin = 0;
export const carsPartialUpdateBodyInstallationYearMax = 2147483647;

export const carsPartialUpdateBodyModernizationYearMin = 0;
export const carsPartialUpdateBodyModernizationYearMax = 2147483647;

export const carsPartialUpdateBodyNumEntrancesMin = 0;
export const carsPartialUpdateBodyNumEntrancesMax = 2147483647;

export const carsPartialUpdateBodySpeedFpmMin = 0;
export const carsPartialUpdateBodySpeedFpmMax = 2147483647;

export const carsPartialUpdateBodyCapacityLbsMin = 0;
export const carsPartialUpdateBodyCapacityLbsMax = 2147483647;



export const CarsPartialUpdateBody = zod.object({
  "clientId": zod.string().max(carsPartialUpdateBodyClientIdMax).nullish(),
  "name": zod.string().min(1).optional(),
  "numLandings": zod.number().min(carsPartialUpdateBodyNumLandingsMin).max(carsPartialUpdateBodyNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(carsPartialUpdateBodyInstallationYearMin).max(carsPartialUpdateBodyInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(carsPartialUpdateBodyModernizationYearMin).max(carsPartialUpdateBodyModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(carsPartialUpdateBodyNumEntrancesMin).max(carsPartialUpdateBodyNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(carsPartialUpdateBodySpeedFpmMin).max(carsPartialUpdateBodySpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(carsPartialUpdateBodyCapacityLbsMin).max(carsPartialUpdateBodyCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullish()
}).describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

export const carsPartialUpdateResponseClientIdMax = 255;

export const carsPartialUpdateResponseNumLandingsMin = 0;
export const carsPartialUpdateResponseNumLandingsMax = 2147483647;

export const carsPartialUpdateResponsePropertyOneAddressOneRawMax = 200;

export const carsPartialUpdateResponsePropertyOneAddressOneFormattedMax = 200;

export const carsPartialUpdateResponsePropertyOneAddressOneStreetNumberMax = 20;

export const carsPartialUpdateResponsePropertyOneRegionMax = 255;

export const carsPartialUpdateResponsePropertyOneClientIdMax = 255;

export const carsPartialUpdateResponsePropertyOneLatDefault = 0;
export const carsPartialUpdateResponsePropertyOneLngDefault = 0;
export const carsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const carsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const carsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const carsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const carsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const carsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const carsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const carsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const carsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const carsPartialUpdateResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const carsPartialUpdateResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const carsPartialUpdateResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsPartialUpdateResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const carsPartialUpdateResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const carsPartialUpdateResponsePropertyOneBuildingNumberMax = 255;

export const carsPartialUpdateResponsePropertyOneContactOneNameMax = 255;

export const carsPartialUpdateResponseInstallationYearMin = 0;
export const carsPartialUpdateResponseInstallationYearMax = 2147483647;

export const carsPartialUpdateResponseModernizationYearMin = 0;
export const carsPartialUpdateResponseModernizationYearMax = 2147483647;

export const carsPartialUpdateResponseNumEntrancesMin = 0;
export const carsPartialUpdateResponseNumEntrancesMax = 2147483647;

export const carsPartialUpdateResponseSpeedFpmMin = 0;
export const carsPartialUpdateResponseSpeedFpmMax = 2147483647;

export const carsPartialUpdateResponseCapacityLbsMin = 0;
export const carsPartialUpdateResponseCapacityLbsMax = 2147483647;



export const CarsPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(carsPartialUpdateResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(carsPartialUpdateResponseNumLandingsMin).max(carsPartialUpdateResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(carsPartialUpdateResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(carsPartialUpdateResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(carsPartialUpdateResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(carsPartialUpdateResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(carsPartialUpdateResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(carsPartialUpdateResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(carsPartialUpdateResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(carsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsPartialUpdateResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(carsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsPartialUpdateResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(carsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(carsPartialUpdateResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(carsPartialUpdateResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsPartialUpdateResponsePropertyOneAssignedConsultantOneUsernameMax).regex(carsPartialUpdateResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsPartialUpdateResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsPartialUpdateResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(carsPartialUpdateResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(carsPartialUpdateResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(carsPartialUpdateResponseInstallationYearMin).max(carsPartialUpdateResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(carsPartialUpdateResponseModernizationYearMin).max(carsPartialUpdateResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(carsPartialUpdateResponseNumEntrancesMin).max(carsPartialUpdateResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(carsPartialUpdateResponseSpeedFpmMin).max(carsPartialUpdateResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(carsPartialUpdateResponseCapacityLbsMin).max(carsPartialUpdateResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const CarsDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.')
})

export const CarsDestroyResponse = zod.void()

/**
 * Get basic certificate information for a specific car.
 * URL: /api/v1/cars/{car_id}/certificates/
 */
export const CarsCertificatesListParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.')
})

export const CarsCertificatesListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional()
})

export const CarsCertificatesListResponseItem = zod.object({
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "downloadUrl": zod.string().nullable()
}).strict()
export const CarsCertificatesListResponse = zod.array(CarsCertificatesListResponseItem)

/**
 * Get compliance documents (certificates, inspection reports, violations,
 * and contracts) for a specific car.
 * URL: /api/v1/cars/{car_id}/compliance_documents/
 */
export const CarsComplianceDocumentsListParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.')
})

export const CarsComplianceDocumentsListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional()
})

export const CarsComplianceDocumentsListResponseItem = zod.object({
  "dateIssued": zod.string().date().nullable(),
  "expirationDate": zod.string().date().nullable(),
  "downloadUrl": zod.string().nullable(),
  "documentType": zod.string()
}).strict().describe('One row of the ``compliance_documents`` action (certificate, inspection\nreport, violation or contract attachment).')
export const CarsComplianceDocumentsListResponse = zod.array(CarsComplianceDocumentsListResponseItem)

/**
 * Asset history: every record tagged to this car as a normalized,
 * date-sorted timeline (invoices, proposals, credits, tickets, violations,
 * inspection reports, certificates, and the governing contracts).
 *
 * URL: /api/v1/cars/{car_id}/history/
 * Optional ``?type=`` narrows which record types are returned. Access is
 * scoped by ``get_object`` (404 if the car is not visible to the caller),
 * so every sub-query is already limited to a car the caller may see.
 */
export const CarsHistoryListParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.')
})

export const CarsHistoryListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional(),
  "type": zod.string().optional().describe('Comma-separated record types to include (invoice, proposal, credit, ticket, violation, inspection_report, certificate, contract). Defaults to all types.')
})

export const carsHistoryListResponseAmountRegExp = new RegExp('^-?\\d{0,10}(?:\\.\\d{0,2})?$');


export const CarsHistoryListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "type": zod.enum(['invoice', 'proposal', 'credit', 'ticket', 'violation', 'inspection_report', 'certificate', 'contract']).describe('\* `invoice` - invoice\n\* `proposal` - proposal\n\* `credit` - credit\n\* `ticket` - ticket\n\* `violation` - violation\n\* `inspection_report` - inspection_report\n\* `certificate` - certificate\n\* `contract` - contract'),
  "title": zod.string(),
  "subtitle": zod.string().nullable(),
  "amount": zod.string().regex(carsHistoryListResponseAmountRegExp).nullable(),
  "eventDate": zod.string().date().nullable(),
  "status": zod.string().nullable(),
  "source": zod.object({
  "kind": zod.string(),
  "id": zod.string().uuid()
}).strict().describe('The underlying record a timeline row links out to.'),
  "isCoverage": zod.boolean()
}).strict().describe('One normalized row of the ``history`` action: an invoice, proposal,\nticket, violation, inspection report, certificate, or contract, reduced to\na common shape the timeline renders and sorts on.')
export const CarsHistoryListResponse = zod.array(CarsHistoryListResponseItem)

/**
 * Get basic violation information for a specific car.
 * URL: /api/v1/cars/{car_id}/violations/
 */
export const CarsViolationsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this car.')
})

export const carsViolationsRetrieveResponseResultsItemCodeMax = 100;

export const carsViolationsRetrieveResponseResultsItemLocationMax = 255;

export const carsViolationsRetrieveResponseResultsItemCustomResolutionTypeMax = 100;



export const CarsViolationsRetrieveResponse = zod.object({
  "statistics": zod.object({
  "open": zod.number(),
  "overdue": zod.number(),
  "resolved": zod.number(),
  "total": zod.number()
}).strict(),
  "results": zod.array(zod.object({
  "id": zod.string().uuid(),
  "code": zod.string().max(carsViolationsRetrieveResponseResultsItemCodeMax).optional().describe('The violation code'),
  "severity": zod.union([zod.enum(['A', 'B', 'C']).describe('\* `A` - A (Urgent)\n\* `B` - B (Standard)\n\* `C` - C (Observation)'),zod.enum(['']),zod.literal(null)]).nullish().describe('LOLER defect category (A=urgent, B=standard, C=observation); null for US\/non-LOLER defects\n\n\* `A` - A (Urgent)\n\* `B` - B (Standard)\n\* `C` - C (Observation)'),
  "location": zod.string().max(carsViolationsRetrieveResponseResultsItemLocationMax).nullish().describe('Where the violation was observed'),
  "dateOpen": zod.string().datetime({"offset":true}).describe('Date and time when the violation was first opened'),
  "correctionDue": zod.string().date().nullish().describe('The date by which the violation must be corrected. Optional only for LOLER category C defects, which carry no deadline; required for every other defect, including US ones (severity NULL).'),
  "createdAt": zod.string().datetime({"offset":true}),
  "resolvedDt": zod.string().datetime({"offset":true}).nullish().describe('When the violation was resolved (Leave blank for new violation)'),
  "status": zod.string(),
  "description": zod.string().describe('Detailed description of the violation'),
  "responsibility": zod.union([zod.enum(['county', 'owner', 'service_provider']).describe('\* `county` - County\n\* `owner` - Owner\n\* `service_provider` - Service Provider'),zod.enum(['']),zod.literal(null)]).nullish().describe('Who is responsible for correcting the violation\n\n\* `county` - County\n\* `owner` - Owner\n\* `service_provider` - Service Provider'),
  "noteCount": zod.number(),
  "affidavitDownloadUrl": zod.string().nullable(),
  "resolutionType": zod.union([zod.enum(['reinspection', 'waiver', 'affidavit', 'superseded', 'other']).describe('\* `reinspection` - Resolved by Reinspection\n\* `waiver` - Resolved by Waiver\n\* `affidavit` - Resolved by Affidavit\n\* `superseded` - Resolved by Supersession\n\* `other` - Other'),zod.enum(['']),zod.literal(null)]).nullish().describe('How the violation was resolved\n\n\* `reinspection` - Resolved by Reinspection\n\* `waiver` - Resolved by Waiver\n\* `affidavit` - Resolved by Affidavit\n\* `superseded` - Resolved by Supersession\n\* `other` - Other'),
  "customResolutionType": zod.string().max(carsViolationsRetrieveResponseResultsItemCustomResolutionTypeMax).nullish().describe('Custom resolution type description when \'Other\' is selected')
}).strict())
}).strict().describe('The ``{statistics, results}`` envelope returned by the car violations\naction.')

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const CarsAggregateRetrieveQueryParams = zod.object({
  "date_after": zod.string().date().optional().describe('Explicit start of the date range (inclusive).'),
  "date_before": zod.string().date().optional().describe('Explicit end of the date range (inclusive).'),
  "group_by": zod.string().optional().describe('Optional whitelisted group-by dimension (entity-specific, e.g. ``property``, ``portfolio``, ``entry_type``). Omit for a single scalar value; an unknown value returns 400 listing the valid dimensions.'),
  "limit": zod.number().optional().describe('Top-N rows for a grouped result, clamped to [1, 50]. Ignored for scalar results.'),
  "metric": zod.string().describe('Whitelisted metric to compute (entity-specific, e.g. ``invoice_amount``, ``ticket_count``, ``unit_count``). An unknown value returns 400 listing the entity\'s valid metrics.'),
  "period": zod.string().optional().describe('Named relative date range (one of ``30d``\/``90d``\/``ytd``\/``ttm``\/``all``\/``custom``) resolved into the entity\'s date filter. ``all`` applies no date bound at all. Routed to ``dropped_filters`` for entities without a date filter.')
})

export const CarsAggregateRetrieveResponse = zod.union([zod.object({
  "entity": zod.string(),
  "metric": zod.string(),
  "value": zod.number().nullable(),
  "filtersApplied": zod.record(zod.string(), zod.unknown()),
  "droppedFilters": zod.record(zod.string(), zod.unknown())
}).strict().describe('Ungrouped aggregate: a single scalar ``value`` for the whole scope.'),zod.object({
  "entity": zod.string(),
  "metric": zod.string(),
  "groupBy": zod.string(),
  "rows": zod.array(zod.object({
  "group": zod.string().nullable(),
  "value": zod.number().nullable()
}).strict().describe('One row of a grouped aggregate: a display label and its metric value.')),
  "total": zod.number().nullable(),
  "groupCount": zod.number(),
  "shown": zod.number(),
  "truncated": zod.boolean(),
  "filtersApplied": zod.record(zod.string(), zod.unknown()),
  "droppedFilters": zod.record(zod.string(), zod.unknown())
}).strict().describe('Grouped aggregate: top-N rows plus the grand total and group count.')])

/**
 * Trimmed CarForm list for form dropdowns (SDK: carsFormList).
 *
 * Separate endpoint so the generated type is the precise CarForm shape;
 * the old ``?variant=form`` query param can't be typed per-value in OpenAPI.
 * Honors the same filters as the default list (e.g. property/portfolio).
 */
export const CarsFormListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional()
})

export const carsFormListResponsePropertyOneAddressOneRawMax = 200;

export const carsFormListResponsePropertyOneAddressOneFormattedMax = 200;

export const carsFormListResponsePropertyOneAddressOneStreetNumberMax = 20;

export const carsFormListResponsePropertyOneRegionMax = 255;

export const carsFormListResponsePropertyOneClientIdMax = 255;

export const carsFormListResponsePropertyOneLatDefault = 0;
export const carsFormListResponsePropertyOneLngDefault = 0;
export const carsFormListResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const carsFormListResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsFormListResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const carsFormListResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const carsFormListResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const carsFormListResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsFormListResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const carsFormListResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const carsFormListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const carsFormListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsFormListResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const carsFormListResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const carsFormListResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const carsFormListResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const carsFormListResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsFormListResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const carsFormListResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const carsFormListResponsePropertyOneBuildingNumberMax = 255;

export const carsFormListResponsePropertyOneContactOneNameMax = 255;



export const CarsFormListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(carsFormListResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(carsFormListResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(carsFormListResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(carsFormListResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(carsFormListResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(carsFormListResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(carsFormListResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsFormListResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(carsFormListResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsFormListResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsFormListResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsFormListResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(carsFormListResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsFormListResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsFormListResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsFormListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(carsFormListResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsFormListResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(carsFormListResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(carsFormListResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsFormListResponsePropertyOneAssignedConsultantOneUsernameMax).regex(carsFormListResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsFormListResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsFormListResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(carsFormListResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(carsFormListResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')
export const CarsFormListResponse = zod.array(CarsFormListResponseItem)

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const CarsKpisByPropertyIdListParams = zod.object({
  "propertyId": zod.string().uuid().describe('UUID of the property.')
})

export const CarsKpisByPropertyIdListQueryParams = zod.object({
  "client_id": zod.array(zod.string()).optional().describe('Multiple values may be separated by commas.'),
  "end_date": zod.string().optional(),
  "ordering": zod.array(zod.enum(['-name', 'name'])).optional().describe('Ordering\n\n\* `name` - Name\n\* `-name` - Name (descending)'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "query": zod.string().optional(),
  "search_cars": zod.string().optional(),
  "start_date": zod.string().optional()
})

export const CarsKpisByPropertyIdListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "ahjId": zod.string(),
  "name": zod.string(),
  "criticalUnit": zod.boolean(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.literal(null)]).nullable(),
  "installationYear": zod.number().nullable(),
  "modernizationYear": zod.number().nullable(),
  "numLandings": zod.number().nullable(),
  "speedFpm": zod.number().nullable(),
  "capacityLbs": zod.number().nullable(),
  "controllerModel": zod.string(),
  "driveType": zod.string(),
  "lastSspiTest": zod.string().date().nullable(),
  "lastCat1Test": zod.string().date().nullable(),
  "lastCat5Test": zod.string().date().nullable(),
  "numEntrances": zod.number().nullable(),
  "oem": zod.string().nullable(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "callbacks": zod.number().nullable(),
  "callbackRate": zod.number().nullable(),
  "meanTimeBetweenCallbackSecs": zod.number().nullable(),
  "emergencyCallbackRate": zod.number().nullable(),
  "emergencyCalls": zod.number().nullable(),
  "maintenanceCompletion": zod.number().nullable(),
  "maintenanceHours": zod.number().nullable(),
  "maintenanceVisits": zod.number().nullable(),
  "maintenanceFrequency": zod.string(),
  "onTimeResponse": zod.number().nullable(),
  "regularCallbackRateTarget": zod.number(),
  "emergencyCallbackRateTarget": zod.number()
}).strict()
export const CarsKpisByPropertyIdListResponse = zod.array(CarsKpisByPropertyIdListResponseItem)

/**
 * List cars whose maintenance completion fell below the threshold
 * for the given month.
 */
export const carsMissedMaintenanceRetrieveResponseClientIdMax = 255;

export const carsMissedMaintenanceRetrieveResponseNumLandingsMin = 0;
export const carsMissedMaintenanceRetrieveResponseNumLandingsMax = 2147483647;

export const carsMissedMaintenanceRetrieveResponsePropertyOneAddressOneRawMax = 200;

export const carsMissedMaintenanceRetrieveResponsePropertyOneAddressOneFormattedMax = 200;

export const carsMissedMaintenanceRetrieveResponsePropertyOneAddressOneStreetNumberMax = 20;

export const carsMissedMaintenanceRetrieveResponsePropertyOneRegionMax = 255;

export const carsMissedMaintenanceRetrieveResponsePropertyOneClientIdMax = 255;

export const carsMissedMaintenanceRetrieveResponsePropertyOneLatDefault = 0;
export const carsMissedMaintenanceRetrieveResponsePropertyOneLngDefault = 0;
export const carsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax = 150;


export const carsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneEmailMax = 254;

export const carsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax = 128;

export const carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax = 150;


export const carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneEmailMax = 254;

export const carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax = 128;

export const carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax = 150;


export const carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax = 254;

export const carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax = 128;

export const carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneFileRegExp = new RegExp('(?:jpg|png|jpeg)$');
export const carsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneUsernameMax = 150;


export const carsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const carsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneEmailMax = 254;

export const carsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOnePhoneNumberMax = 128;

export const carsMissedMaintenanceRetrieveResponsePropertyOneBuildingNumberMax = 255;

export const carsMissedMaintenanceRetrieveResponsePropertyOneContactOneNameMax = 255;

export const carsMissedMaintenanceRetrieveResponseInstallationYearMin = 0;
export const carsMissedMaintenanceRetrieveResponseInstallationYearMax = 2147483647;

export const carsMissedMaintenanceRetrieveResponseModernizationYearMin = 0;
export const carsMissedMaintenanceRetrieveResponseModernizationYearMax = 2147483647;

export const carsMissedMaintenanceRetrieveResponseNumEntrancesMin = 0;
export const carsMissedMaintenanceRetrieveResponseNumEntrancesMax = 2147483647;

export const carsMissedMaintenanceRetrieveResponseSpeedFpmMin = 0;
export const carsMissedMaintenanceRetrieveResponseSpeedFpmMax = 2147483647;

export const carsMissedMaintenanceRetrieveResponseCapacityLbsMin = 0;
export const carsMissedMaintenanceRetrieveResponseCapacityLbsMax = 2147483647;



export const CarsMissedMaintenanceRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "clientId": zod.string().max(carsMissedMaintenanceRetrieveResponseClientIdMax).nullish(),
  "customerAccounts": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')),
  "name": zod.string(),
  "status": zod.string(),
  "numLandings": zod.number().min(carsMissedMaintenanceRetrieveResponseNumLandingsMin).max(carsMissedMaintenanceRetrieveResponseNumLandingsMax).nullish(),
  "elevatorType": zod.union([zod.enum(['Traction', 'Hydro', 'Other', 'escalator', 'hydraulic-passenger', 'hydraulic-service', 'mrl-traction', 'geared-passenger', 'geared-traction', 'gearless-traction', 'gearless-passenger', 'wheelchair-lift', 'dumbwaiter', 'passenger-service', 'high-rise-passenger', 'low-rise-passenger', 'passenger', 'freight']).describe('\* `Traction` - Traction\n\* `Hydro` - Hydro\n\* `Other` - Other\n\* `escalator` - Escalator\n\* `hydraulic-passenger` - Hydraulic Passenger\n\* `hydraulic-service` - Hydraulic Service\n\* `mrl-traction` - MRL Traction\n\* `geared-passenger` - Geared Passenger\n\* `geared-traction` - Geared Traction\n\* `gearless-traction` - Gearless Traction\n\* `gearless-passenger` - Gearless Passenger\n\* `wheelchair-lift` - Wheelchair Lift\n\* `dumbwaiter` - Dumbwaiter\n\* `passenger-service` - Passenger\/Service\n\* `high-rise-passenger` - High Rise Passenger\n\* `low-rise-passenger` - Low Rise Passenger\n\* `passenger` - Passenger\n\* `freight` - Freight'),zod.enum(['']),zod.literal(null)]).nullish(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "name": zod.string(),
  "address": zod.object({
  "id": zod.number(),
  "raw": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneAddressOneRawMax),
  "formatted": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneAddressOneFormattedMax).optional(),
  "streetNumber": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneAddressOneStreetNumberMax).optional(),
  "street": zod.string(),
  "city": zod.string().nullable(),
  "postalCode": zod.string().nullable(),
  "state": zod.string().nullable(),
  "country": zod.string().nullable()
}).strict().nullable(),
  "region": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneRegionMax).nullish(),
  "clientId": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneClientIdMax).nullish(),
  "timeZone": zod.string().optional(),
  "lat": zod.number().nullable().default(carsMissedMaintenanceRetrieveResponsePropertyOneLatDefault),
  "lng": zod.number().nullable().default(carsMissedMaintenanceRetrieveResponsePropertyOneLngDefault),
  "propertyManager": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameMax).regex(carsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOnePropertyManagerOneOwnerOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable()
}).strict().nullable(),
  "consultantGroup": zod.object({
  "name": zod.string(),
  "id": zod.string().uuid(),
  "owner": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameMax).regex(carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneOwnerOnePhoneNumberMax).optional()
}).strict().nullable(),
  "consultants": zod.array(zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameMax).regex(carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "fullName": zod.string(),
  "email": zod.string().email().max(carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemEmailMax).optional(),
  "phoneNumber": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneConsultantsItemPhoneNumberMax).optional()
}).strict()),
  "file": zod.string().url().regex(carsMissedMaintenanceRetrieveResponsePropertyOneConsultantGroupOneFileRegExp).nullish()
}).strict().nullable(),
  "assignedConsultant": zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneUsernameMax).regex(carsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(carsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOneEmailMax).optional(),
  "phoneNumber": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneAssignedConsultantOnePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "unitCount": zod.number(),
  "buildingNumber": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneBuildingNumberMax).optional(),
  "contact": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().max(carsMissedMaintenanceRetrieveResponsePropertyOneContactOneNameMax),
  "email": zod.string().email().nullish(),
  "phone": zod.string().nullish(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict().nullish()
}).strict(),
  "serviceProviderId": zod.string().uuid().nullable(),
  "ahjId": zod.string().optional(),
  "criticalUnit": zod.boolean().optional(),
  "installationYear": zod.number().min(carsMissedMaintenanceRetrieveResponseInstallationYearMin).max(carsMissedMaintenanceRetrieveResponseInstallationYearMax).nullish(),
  "modernizationYear": zod.number().min(carsMissedMaintenanceRetrieveResponseModernizationYearMin).max(carsMissedMaintenanceRetrieveResponseModernizationYearMax).nullish(),
  "numEntrances": zod.number().min(carsMissedMaintenanceRetrieveResponseNumEntrancesMin).max(carsMissedMaintenanceRetrieveResponseNumEntrancesMax).nullish(),
  "speedFpm": zod.number().min(carsMissedMaintenanceRetrieveResponseSpeedFpmMin).max(carsMissedMaintenanceRetrieveResponseSpeedFpmMax).nullish(),
  "capacityLbs": zod.number().min(carsMissedMaintenanceRetrieveResponseCapacityLbsMin).max(carsMissedMaintenanceRetrieveResponseCapacityLbsMax).nullish(),
  "lastSspiTest": zod.string().date().nullish(),
  "lastCat1Test": zod.string().date().nullish(),
  "lastCat5Test": zod.string().date().nullish(),
  "driveType": zod.string().optional(),
  "controllerModel": zod.string().optional(),
  "oem": zod.string().uuid().nullable(),
  "manufacturer": zod.string().nullable(),
  "serviceProviderInternalId": zod.string().nullable()
}).strict().describe('A subclass of DRF\'s ModelSerializer which realizes when fields it is\nserializing are to related objects which also have NestableModelSerializers\ndefined for them and uses those serializers instead of the default\nModelSerializer that DRF would use.\n\nThis ModelSerializer takes an additional `fields` argument that\ncontrols which fields should be displayed.\nFor more information, refer to the documentation:\nhttps:\/\/www.django-rest-framework.org\/api-guide\/serializers\/#dynamically-modifying-fields\n\n\nExample:\nPortfolioSerializer(required=False, fields=[\"id\", \"name\"])')

